<template>
  <div
    class="service"
    vkshop-event-scope="clientService"
    v-if="!isStudentCenterApp"
  >
    <div class="fixed-contain">
      <ul class="right-fixed-con">
        <li>
          <img
            class="icon"
            src="@/assets/images/service-client/service-wechat.png"
            alt="wechat"
          >
          <p>服务号</p>
          <div
            class="erweima"
            id="erweima"
          >
            <img
              class="con"
              src="@/assets/images/service-client/erweima.png"
              alt="qr-code"
            >
            <img
              class="rectangle"
              src="@/assets/images/service-client/right-angle.png"
              alt="angle"
            >
          </div>
        </li>
        <li>
          <img
            class="icon"
            src="@/assets/images/service-client/telphone.png"
            alt="telphone"
          >
          <p>电话咨询</p>
          <div
            class="tips"
            id="teltips"
          >
            <div class="text">
              <p>9517510</p>
              <p>010-50870412</p>
            </div>
            <img
              class="rectangle"
              src="@/assets/images/service-client/right-angle-yel.png"
              alt="angle"
            >
          </div>
        </li>
        <li
          class="js-online-service"
          vkshop-event-name="callIM"
          vkshop-event-type="click"
          @click="openChatWindow"
        >
          <img
            class="icon"
            src="@/assets/images/service-client/online-service.png"
            alt="online-service"
          >
          <p>在线咨询</p>
          <div class="tips zixun">
            <div class="text">点击开始 在线咨询</div>
            <img
              class="rectangle"
              src="@/assets/images/service-client/right-angle-blue.png"
              alt=""
            >
          </div>
        </li>
      </ul>
    </div>
    <iframe
      v-if="!destory"
      v-show="!miniShow"
      class="iframe-style"
      :src="origin + '/ittest'"
      frameborder="0"
      id="iframeChat"
      ref="iframeChat"
      @load="iframeLoad"
      scrolling="no"
    ></iframe>
  </div>
</template>
<script>
import imBus from '@/eventBus/imBus.js'

export default {
  name: 'clintService',
  data() {
    return {
      isStudentCenterApp: window.navigator.userAgent.includes('VIPKID') && window.navigator.userAgent.includes('PCStudent'), // 用来判断是否在学习中心app
      message: {
        accessMode: 'Guest', // 聊天模式
        allowMultiLogin: false, //是否允许多处登录
        chatWidth: 360, //聊天客户端宽度
        chatHeight: 540, //聊天客户端高度
      },
      destory: true,
      miniShow: false,
      origin: window.$config.im
    }
  },/*  */
  mounted() {
    if (!(window.navigator.userAgent.includes('VIPKID') && window.navigator.userAgent.includes('PCStudent'))) {
       window.addEventListener('message', this.receiveMsg, false)
       imBus.$on('changeIm', this.openChatWindow)
    }
    // var zhiManager = getzhiSDKInstance()
    // zhiManager.set('manTrance', 'true')
    // zhiManager.set('customBtn', 'true')
    // zhiManager.on('load', function(ret) {
    //   zhiManager.initBtnDOM()
    // })
  },
  beforeDestroy() {
    imBus.$off('changeIm')
  },
  methods: {
    receiveMsg(event) {
      const origin = event.origin || event.originalEvent.origin;
      if (origin != this.origin) {
        return;
      }
      switch (event.data.chatWindow) {
        case 'close': // 关闭窗口
          console.log('关闭窗口');
          this.destory = true;
          this.miniShow = false;
          break;

        case 'hide': // 隐藏窗口
          console.log('隐藏窗口');
          this.destory = false;
          this.miniShow = true;
          break;

      }
    },
    iframeLoad() { // iframe loaded之后向IM聊天系统页面传值
      let iFrame = document.getElementById('iframeChat');
      iFrame.contentWindow.postMessage(JSON.stringify(this.message), this.origin);
    },
    openChatWindow() { // 打开/最大化聊天窗口
    console.log(111)
      if (this.destory) { // 已关闭窗口，重新打开窗口
        this.destory = false;
        this.miniShow = false;
      } else if (!this.destory && this.miniShow) { // 窗口存在，显示窗口
        this.miniShow = false;
      } else if (!this.destory && !this.miniShow) { // 窗口存在，隐藏窗口
        this.miniShow = true;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.service {
  .iframe-style {
    display: block;
    width: 380px;
    height: 560px;
    position: fixed;
    bottom: 20px;
    right: 120px;
    z-index: 1000;
  }

  .show-chat-window {
    position: fixed;
    right: 30px;
    bottom: 50px;
    width: 50px;
    height: 50px;
    background: #f85415;
    border-radius: 100%;
    cursor: pointer;
    line-height: 50px;
    color: #ffffff;
    bottom: 100px;
  }

  .fixed-contain {
    position: fixed;
    right: 30px;
    top: 50%;
    margin-top: -110px;
    z-index: 100;
    width: 65px;
    height: 220px;
    transform: translateZ(0);
    .right-fixed-con {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 80;
      width: 64px;
      height: 220px;
      background: #fff;
      box-shadow: 0 12px 15px 0 rgba(71, 71, 71, 0.1),
        0 20px 60px 0 rgba(71, 71, 71, 0.11);
      border-radius: 25px;
      text-align: center;
      li {
        position: relative;
        padding-top: 17px;
        cursor: pointer;
        width: 65px;
        height: 65px;
        &:hover {
          .erweima,
          .tips {
            display: block;
            animation: tipsShow 0.25s ease-in 1 forwards;
          }
        }
      }
      p {
        font-size: 12px;
        color: #474747;
        padding-top: 4px;
        height: 16px;
        line-height: 1;
      }
      .icon {
        width: 32px;
        margin: 0 auto;
        display: block;
      }
      .erweima {
        display: none;
        padding: 10px;
        position: absolute;
        top: -30px;
        right: 80px;
        width: 150px;
        height: 150px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.06),
          0 15px 40px 0 rgba(0, 0, 0, 0.12);
        .con {
          width: 100%;
        }
        .rectangle {
          position: absolute;
          right: -8px;
          top: 50%;
          margin-top: -8px;
          width: 8px;
        }
      }
      .tips {
        display: none;
        overflow: hidden;
        position: absolute;
        top: 18px;
        right: 80px;
        width: 185px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        .text {
          width: 178px;
          height: 100%;
          background: #ffaf00;
          border-radius: 4px;
          color: #fff;
          font-size: 16px;
          p{
            color: #fff;
            font-size: 16px;
            line-height: 26px;
          }
        }
        .rectangle {
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -8px;
          width: 8px;
        }
        &.zixun {
          .text {
            background: #428dff;
          }
        }
      }
    }
  }
}
@keyframes tipsShow {
  0% {
    opacity: 0.2;
    ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=20)";
    filter: alpha(opacity=20);
    right: 70px;
  }
  100% {
    opacity: 1;
    -ms-filter: none;
    filter: none;
    right: 80px;
  }
}
</style>